import React, { useContext } from 'react';
import Close from '../../../Icons/24x24/Close';
import IconButton from '../../../Buttons/IconButton';
import ModalCloseContext from '../../context';

interface Props {
  className?: string;
}

const ModalCloseButton: React.FC<Props> = ({ className }) => {
  const handleClose = useContext(ModalCloseContext);
  return (
    <IconButton
      className={className}
      size="large"
      aria-label="Close"
      icon={Close}
      onClick={handleClose}
    />
  );
};

ModalCloseButton.displayName = 'ModalCloseButton';

export default ModalCloseButton;
